'use es6';

import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import UIList from 'UIComponents/list/UIList';
import { getReport } from 'dashboard-lib/public/widget/widget-schema';
import { isIframeWidget, isNoteWidget } from 'reporting-action-components/lib/report-logic';
import DashboardWidgetErrorBoundary from '../widgets/DashboardWidgetErrorBoundary';
import { WidgetContextProvider } from '../widgets/WidgetContext';
import { selectForceRenderCount } from '../../ducks/forceRenderCount';
import { AsyncDashboardReportWidget } from '../widgets/AsyncWidgets';
import IframeWidgetBody from '../widgets/IframeWidgetBody';
import NoteWidgetBody from '../widgets/NoteWidgetBody';
import DashboardCardWrapper from '../widgets/common/DashboardCardWrapper';
import { DashboardCardHeader } from '../widgets/common/DashboardCardHeader';
import EditNoteAction from '../widgets/actions/EditNoteAction';
import EditIframeAction from '../widgets/actions/EditIframeAction';
import DeleteNonReportWidgetAction from '../widgets/actions/deleteNonReportWidget/DeleteNonReportWidgetAction';
import RefreshIframeAction from '../widgets/actions/RefreshIframeAction';
import { ViewInSandboxButton } from 'reporting-action-components/reportingActions/viewInSandbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const IframeWidget = ({
  widget,
  isPresentation
}) => {
  const report = getReport(widget);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DashboardCardHeader, {
      isPresentation: isPresentation,
      actionList: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(RefreshIframeAction, {}, "refresh"), /*#__PURE__*/_jsx(EditIframeAction, {}), /*#__PURE__*/_jsx(ViewInSandboxButton, {
          report: report
        }, "sandbox"), /*#__PURE__*/_jsx(DeleteNonReportWidgetAction, {}, "delete")]
      })
    }), /*#__PURE__*/_jsx(IframeWidgetBody, {
      reportRefreshCount: widget.get('reportRefreshCount')
    })]
  });
};
const NoteWidget = ({
  report,
  isPresentation
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(DashboardCardHeader, {
    isPresentation: isPresentation,
    overriddenReport: report,
    actionList: /*#__PURE__*/_jsxs(UIList, {
      children: [/*#__PURE__*/_jsx(EditNoteAction, {}), /*#__PURE__*/_jsx(ViewInSandboxButton, {
        report: report
      }, "sandbox"), /*#__PURE__*/_jsx(DeleteNonReportWidgetAction, {}, "delete")]
    })
  }), /*#__PURE__*/_jsx(NoteWidgetBody, {})]
});
const DashboardGridItem = ({
  dashboard,
  gridUnitWidth,
  canEditWidgets,
  isPresentation,
  widget
}) => {
  const report = widget.get('report');
  const reportId = report.get('id');
  const forceRenderCount = useSelector(selectForceRenderCount);
  const WidgetBody = isIframeWidget(report) ? /*#__PURE__*/_jsx(IframeWidget, {
    widget: widget,
    isPresentation: isPresentation
  }) : isNoteWidget(report) ? /*#__PURE__*/_jsx(NoteWidget, {
    report: report,
    isPresentation: isPresentation
  }) : /*#__PURE__*/_jsx(AsyncDashboardReportWidget, {
    gridUnitWidth: gridUnitWidth,
    isPresentation: isPresentation,
    forceRenderCount: forceRenderCount
  }, reportId);
  return /*#__PURE__*/_jsx(DashboardCardWrapper, {
    widget: widget,
    isPresentation: isPresentation,
    children: /*#__PURE__*/_jsx(DashboardWidgetErrorBoundary, {
      dashboard: dashboard,
      report: report,
      children: /*#__PURE__*/_jsx(WidgetContextProvider, {
        canEditWidgets: canEditWidgets,
        dashboard: dashboard,
        report: report,
        widget: widget,
        children: WidgetBody
      })
    })
  });
};
DashboardGridItem.propTypes = {
  dashboard: PropTypes.instanceOf(ImmutableMap).isRequired,
  gridUnitWidth: PropTypes.number.isRequired,
  canEditWidgets: PropTypes.bool.isRequired,
  isPresentation: PropTypes.bool.isRequired,
  widget: PropTypes.object.isRequired,
  dashboardTracker: PropTypes.object.isRequired
};
export default /*#__PURE__*/memo(DashboardGridItem);